import { Component } from "react"
import VideoViewerFull from "../../../components/pages/VideoViewerFull"
import TreeBoxContents from "../../../components/pages/TreeBoxContents"
import TitleBoxContent from "../../../components/pages/TitleContent"
import ImageBackgroundYoutube from "../../../components/pages/ImageBackgroundYoutube"
import ImageBackgroundMap from "../../../components/pages/ImageBackgroundMap"
import { Mobile, PC, Tablet, Notebook } from "../../ReactiveMode"

class Home extends Component {
  render() {
    const title = ""
    const subTitle = ""
    const buttonTitle = "함께하기"
    const buttonUrl = "/new-family-information"

    return (
      <>
        <Mobile>
          <section className="mf-home">
            <VideoViewerFull
              title={title}
              subTitle={subTitle}
              buttonTitle={buttonTitle}
              buttonUrl={buttonUrl}
            ></VideoViewerFull>
            <TitleBoxContent title="WELCOME" subTitle="성실교회에 오신 여러분을 축복하고 환영합니다." />
            <TreeBoxContents />
            <ImageBackgroundYoutube />
            {/*<ImageBackgroundMap height="500px" title="오시는길" />*/}
          </section>
        </Mobile>

        <Tablet>
          <section className="mf-home">
            <VideoViewerFull
              title={title}
              subTitle={subTitle}
              buttonTitle={buttonTitle}
              buttonUrl={buttonUrl}
            ></VideoViewerFull>
            <TitleBoxContent title="WELCOME" subTitle="성실교회에 오신 여러분을 축복하고 환영합니다." />
            <TreeBoxContents />
            <ImageBackgroundYoutube />
            {/*<ImageBackgroundMap height="500px" title="오시는길" />*/}
          </section>
        </Tablet>

        <Notebook>
          <section className="pf-home">
            <VideoViewerFull
              title={title}
              subTitle={subTitle}
              buttonTitle={buttonTitle}
              buttonUrl={buttonUrl}
            ></VideoViewerFull>
            <TitleBoxContent title="WELCOME" subTitle="성실교회에 오신 여러분을 축복하고 환영합니다." />
            <TreeBoxContents />
            <ImageBackgroundYoutube />
            {/*<ImageBackgroundMap height="600px" title="오시는길" />*/}
          </section>
        </Notebook>

        <PC>
          <section className="pf-home">
            <VideoViewerFull
              title={title}
              subTitle={subTitle}
              buttonTitle={buttonTitle}
              buttonUrl={buttonUrl}
            ></VideoViewerFull>
            <TitleBoxContent title="WELCOME" subTitle="성실교회에 오신 여러분을 축복하고 환영합니다." />
            <TreeBoxContents />
            <ImageBackgroundYoutube />
            {/*<ImageBackgroundMap height="600px" title="오시는길" />*/}
          </section>
        </PC>
      </>
    )
  }
}

export default Home
